var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default (function (props) {
  return React.createElement(
    SvgIcon,
    _extends({ viewBox: '0 0 32 38' }, props),
    React.createElement('path', { d: 'M16 5.728c2.4 0 4.416 2.016 4.416 4.416s-2.016 4.384-4.416 4.384-4.384-1.984-4.384-4.384 1.984-4.416 4.384-4.416zM16 26.528c-3.584 0-6.944-1.856-8.8-4.672 0-2.912 5.856-4.512 8.8-4.512s8.672 1.6 8.8 4.512c-1.856 2.816-5.184 4.672-8.8 4.672zM16 0.256c-8.672 0-15.744 7.072-15.744 15.744s7.072 15.744 15.744 15.744 15.744-7.072 15.744-15.744-7.072-15.744-15.744-15.744zM16 30.016c-7.744 0-13.984-6.272-13.984-14.016s6.24-14.016 13.984-14.016 14.016 6.272 14.016 14.016-6.272 14.016-14.016 14.016z' })
  );
});